import React from 'react';
import './Page.css';
import field from '../../img/field.jpg';

const home = props => (
            <div className="page__home">
                <img alt="field" className="page__home-image" src={field}/>
                <p className="page__home-welcome">Welcome to Leipers Fork RV Rentals</p>
                <div className="page__home-box">
                    <p className="page__home-heading">Find the Perfect RV</p>
                    <p className="page__home-text">Awesome RV rentals for your next adventure!</p>
                    <a href="/?Book"><button className="page__home-find">Find an RV</button></a>
                </div>
            </div>
);

export default home;